import React, { PureComponent } from "react";
import { Icon } from "@vitalsource/vstui";

class Collections extends PureComponent {
  render() {
    return (
      <Icon {...this.props} height={19} width={21}>
        <path d="M16.658 17L2.04 16.998V8h.003l16.916.003L16.66 17zM2.04 2h3.35l.975 2h10.953l.005.005L17.32 6H2.04V2zm17.294 4.042h.03V4.005c0-1.108-.916-2.005-2.046-2.005H7.652L6.983.629a.964.964 0 0 0-.894-.63H.964C.431 0 0 .449 0 1v15.999C0 18.104.915 19 2.043 19h14.615c.987 0 1.834-.692 2.011-1.645l2.298-8.995c.204-1.102-.554-2.12-1.633-2.318z" />
      </Icon>
    );
  }
}

Collections.displayName = "Collections";
Collections.vstuiName = "Icon";

export default Collections;
